import { Component } from '@angular/core';

@Component({
  selector: 'app-client-task-history-item-title',
  template: '<div class="h5 font-weight-bold"><ng-content /></div>',
  standalone: false
})
export class ClientTaskHistoryItemTitleComponent {}
